import { api } from '@/_api'
import Vue from 'vue'

export const publication = {
  namespaced: true,
  state: {
    admin: [],
    types: [],
    statuses: [],
    list: [],
    domens: [],
    fill: new Set(),
    full: new Set(),
    current: 0
  },
  mutations: {
    add(state, publication) {
      state.admin.unshift(Object.assign({}, publication))
    },
    edit(state, publication) {
      let idx = state.admin.findIndex((el, i, arr) => el.id == publication.id)
      state.admin.splice(idx, 1, Object.assign({}, publication))
    },
    remove(state, id) {
      let idx = state.admin.findIndex((el, i, arr) => el.id == id)
      state.admin.splice(idx, 1)
    }
  },
  actions: {
    add({ commit }, { item, callback }) {
      api.publication.create(item).then((d) => {
        if (callback(d))
          commit('add', d)
      })
    },
    edit({ commit }, { item, callback }) {
      api.publication.update(item).then((d) => {
        if (callback(d))
          commit('edit', d);
      })
    },
    remove({ commit }, { id, callback, error }) {
      api.publication.remove(id).then(() => {
        commit('remove', id);
        callback();
      }).catch(e => error(e))
    },
    getByUser({ getters }, user) {
      return getters.getByUser(user)
    },
    getByChannel({ getters }, channel) {
      return getters.getByChannel(channel)
    },
    getBySeries({ getters }, series) {
      return getters.getBySeries(series)
    }
  },
  getters: {
    publications: state => {
      if (state.admin.length == 0)
        api.publication.list()
            .then(data => state.admin = data);
      return state.admin;
    },
    domens: state => {
      if (state.domens.length == 0)
        api.publication.domens()
            .then(data => state.domens = data);
      return state.domens;
    },
    types: state => {
      if (state.types.length == 0)
        api.publication.types()
          .then(data => state.types = data)
      return state.types;
    },
    statuses: state => {
      if (state.statuses.length == 0)
        api.publication.statuses()
          .then(data => state.statuses = data)
      return state.statuses;
    },
    publicationsBySeries: state => series => {
      if (series && !state.fill.has(series)) {
        state.fill.add(series)
        api.publication.list(series)
          .then(data => {
            for(let el of data) {
              if (state.list.findIndex(p => p.id == el.id) == -1)
                state.list.push(el)
            }
          });
      }
      return state.list.filter(p => p.series_id == series)
    },
    getPublication: state => id => {
      if (id && !state.full.has(id)) {
        state.full.add(id)
        api.publication.get(id)
          .then(data => {
            let idx = state.list.findIndex(p => p.id == id)
            if (idx != -1)
              Vue.set(state.list, idx, data)
            else state.list.push(data)
          });
      }
      return state.list.find(p => p.id == id)
    },
    getByUser: state => user => {
      let p = state.list.find(p => p.user_id == user)
      if (p) {
        state.current = p.id
        return state.current
      }
      return api.publication.find(null, null, user)
    },
    getByChannel: state => channel => {
      let p = state.list.find(p => p.channel_id == channel)
      if (p) {
        state.current = p.id
        return state.current
      }
      return api.publication.find(null, channel)
    },
    getBySeries: state => series => {
      let p = state.list.find(p => p.series_id == series)
      if (p) {
        state.current = p.id
        return state.current
      }
      return api.publication.find(series)
    },
  }
}